import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const CornerCluster = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing.medium};
  right: calc(${({ theme }) => theme.spacing.medium} + var(--popety-map-side-offset, 0px));
  z-index: 5;
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.medium};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  ${media.tabletDown} {
    right: ${({ theme }) => theme.spacing.small};
  }
`

export const ToolColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const ToolGroup = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  overflow: hidden;
  box-shadow: 0 4px 16px -1px rgba(0, 0, 0, 0.1);

  /* Tooltip wraps each button, so the divider sits on the wrapper after the first. */
  > * + * {
    border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  }
`

export const ToolButton = styled.button`
  width: 32px;
  height: 32px;
  padding: ${({ theme }) => theme.spacing.small};
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: -2px;
  }

  svg {
    display: block;
    flex-shrink: 0;
  }
`

export const CompassSlot = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== '$bearing',
})<{ $bearing: number }>`
  display: flex;
  transform: rotate(${({ $bearing }) => -$bearing}deg);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`

export const BasemapToggle = styled.button`
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing.small};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  cursor: pointer;
  line-height: 0;
  overflow: hidden;
  box-shadow: 0 4px 16px -1px rgba(0, 0, 0, 0.1);
  transition: padding 250ms;
  img {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    display: block;
  }

  &:hover {
    padding: 5px;
    border-color: ${({ theme }) => theme.colors.border.default};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }
`

export const BasemapLabel = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== '$onImagery',
})<{ $onImagery?: boolean }>`
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: 16px;
  white-space: nowrap;
  pointer-events: none;
  color: ${({ theme, $onImagery }) =>
    $onImagery ? theme.colors.text.inverse : theme.colors.text.primary};
  text-shadow: ${({ $onImagery }) => ($onImagery ? '0 4px 4px rgba(0, 0, 0, 0.5)' : 'none')};
`
